import { validateFile, validateUrl } from '@/lib/utils';

export type ValidationResult = {
  isValid: boolean;
  error?: string;
};

export interface DocumentValidator {
  validate(): ValidationResult;
}

export class FileDocumentValidator implements DocumentValidator {
  private file: File | null;

  constructor(file: File | null) {
    this.file = file;
  }

  validate(): ValidationResult {
    if (!this.file) {
      return { isValid: false, error: 'No file selected' };
    }

    const error = validateFile(this.file);
    if (error) {
      return { isValid: false, error };
    }

    return { isValid: true };
  }
}

export class UrlDocumentValidator implements DocumentValidator {
  private url: string;

  constructor(url: string) {
    this.url = url;
  }

  validate(): ValidationResult {
    if (!this.url.trim()) {
      return { isValid: false, error: 'URL is required' };
    }

    if (!validateUrl(this.url)) {
      return {
        isValid: false,
        error: 'Please enter a valid URL starting with http:// or https://',
      };
    }

    return { isValid: true };
  }
}

export class TextDocumentValidator implements DocumentValidator {
  private name: string;
  private content: string;

  constructor(name: string, content: string) {
    this.name = name;
    this.content = content;
  }

  validate(): ValidationResult {
    if (!this.name.trim() || !this.content.trim()) {
      return { isValid: false, error: 'Both text name and content are required' };
    }

    return { isValid: true };
  }
}
